// extracted by mini-css-extract-plugin
export var bigHoverActionButton = "mGATq";
export var bigHoverActionContainer = "QpoLy";
export var slvBigHover = "LKpyr";
export var slvCompact = "rP5cw";